import React from "react";
import { Tooltip } from "antd";
import { CustomInput } from "./CustomInput";

const CustomInputWithTooltip = ({ value, ...props }) => {
  return (
    <Tooltip title={value}>
      <CustomInput value={value} {...props} />
    </Tooltip>
  );
};

export { CustomInputWithTooltip };
